import { Grid, IconButton, Tooltip } from "@material-ui/core";

import DetalleHistoriaClinica from "./DetalleHistoriaClinica";
import { Fragment } from "react";
import InfoIcon from "@material-ui/icons/Info";
import MeditocActions from "../../../utils/MeditocActions";
import MeditocTable from "../../../utils/MeditocTable";
import { getHistorialClinicoColumns } from "../../../../models/CallCenterModel";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function HistorialClinico() {
    const {
        entCallCenter,
        historiaClinica,
        handleChangeHistoriaClinica,
        handleClickDetalleHistoriaClinica,
    } = useCallCenter();

    const { lstHistorialClinico } = entCallCenter;

    return (
        <Fragment>
            <MeditocActions title="Historia clínica del paciente">
                <Tooltip
                    arrow
                    placement="top"
                    title="Haga doble clic sobre un registro para ver el detalle del historial"
                >
                    <IconButton color="primary">
                        <InfoIcon />
                    </IconButton>
                </Tooltip>
            </MeditocActions>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MeditocTable
                        id="iIdHistorialClinico"
                        row={historiaClinica}
                        data={lstHistorialClinico}
                        columns={getHistorialClinicoColumns()}
                        setRow={handleChangeHistoriaClinica}
                        fnDoubleClick={handleClickDetalleHistoriaClinica}
                    />
                </Grid>
            </Grid>
            <DetalleHistoriaClinica />
        </Fragment>
    );
}
